import Marquee from "react-fast-marquee";
import { useTranslation } from "react-i18next";
import { PRESS_MENTIONS } from "@/data/press";

export default function FeaturedIn() {
  const { t } = useTranslation();
  return (
    <section data-testid="featured-in" className="py-12 bg-transparent">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-6">
          <span className="font-mono text-[10px] text-[color:var(--text-3)] tracking-[0.3em] uppercase">{t("news.seenOn", "As seen on")}</span>
        </div>
        <div
          style={{
            WebkitMaskImage:
              "linear-gradient(90deg, transparent 0, #000 96px, #000 calc(100% - 96px), transparent 100%)",
            maskImage:
              "linear-gradient(90deg, transparent 0, #000 96px, #000 calc(100% - 96px), transparent 100%)",
          }}
        >
          <Marquee gradient={false} speed={32} pauseOnHover>
            {PRESS_MENTIONS.map((p) => (
              <a
                key={p.key}
                href={p.url}
                target="_blank"
                rel="noreferrer"
                data-testid={`featured-in-${p.key}`}
                className="group mx-7 flex items-center gap-2.5 font-display text-lg lg:text-xl font-medium text-[color:var(--text-3)] hover:text-[color:var(--text-1)] transition-colors"
              >
                {p.icon && (
                  <img src={p.icon} alt="" className="w-5 h-5 rounded grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300" loading="lazy" />
                )}
                {p.name}
              </a>
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
}
